import { render, staticRenderFns } from "./RevisionMutationV1.vue?vue&type=template&id=5ffc8bd4&"
import script from "./RevisionMutationV1.vue?vue&type=script&lang=js&"
export * from "./RevisionMutationV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports